import { DhSummaryStrip, type SummaryItem } from '../../departmentHead/ui';

export interface OverviewSummaryStripProps {
  progressPct: number | null;
  departments: number | null;
  scheduleLines: number | null;
  wbsDepth: number | null;
  dcCapacityMw: number | null;
  acCapacityMw: number | null;
  teamCount: number | null;
  currentRevision: number | null;
}

export function OverviewSummaryStrip(p: OverviewSummaryStripProps) {
  const capacity =
    p.dcCapacityMw == null && p.acCapacityMw == null ? (
      '—'
    ) : (
      <>
        {p.dcCapacityMw ?? '—'}{' '}
        <small className="text-[11px] font-semibold text-[#94a3b8]">DC / {p.acCapacityMw ?? '—'} AC MW</small>
      </>
    );
  const items: SummaryItem[] = [
    p.progressPct == null
      ? { label: 'Overall progress', value: '—' }
      : { label: 'Overall progress', value: `${p.progressPct}%`, progressPct: p.progressPct },
    { label: 'Departments', value: p.departments ?? '—' },
    { label: 'Schedule lines', value: p.scheduleLines ?? '—' },
    { label: 'WBS depth', value: p.wbsDepth == null ? '—' : `L${p.wbsDepth}` },
    { label: 'Capacity', value: capacity },
    { label: 'Team', value: p.teamCount ?? '—' },
    {
      label: 'Plan revisions',
      value:
        p.currentRevision == null ? (
          '—'
        ) : (
          <>
            <span className={p.currentRevision > 1 ? 'text-[#b45309]' : ''}>R{p.currentRevision}</span>{' '}
            <small className="text-[11px] font-semibold text-[#94a3b8]">current</small>
          </>
        ),
    },
  ];
  return <DhSummaryStrip items={items} />;
}
